import {
    ComponentFactoryResolver,
    Directive,
    EmbeddedViewRef,
    Input,
    OnChanges,
    SimpleChanges,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { MatSpinnerContainerComponent } from '../components/mat-spinner-container/mat-spinner-container.component';

@Directive({
    selector: '[appShowSpinner]',
    standalone: false,
})
export class ShowSpinnerDirective implements OnChanges {
    @Input('appShowSpinner') showSpinner = false;
    @Input('appShowSpinnerDiameter') diameter = 35;
    @Input('appShowSpinnerStrokeWidth') strokeWidth = 4;

    private embeddedView: EmbeddedViewRef<any> | null = null;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.showSpinner && changes.showSpinner.previousValue !== changes.showSpinner.currentValue) {
            this.updateView();
        }
    }

    private updateView(): void {
        if (this.showSpinner && this.embeddedView) {
            // get the first node
            const [componentNativeElement] = this.embeddedView.rootNodes;

            // get the computed width/height (which includes padding)
            const width = componentNativeElement.offsetWidth;
            const height = componentNativeElement.offsetHeight;

            // get the margin of the element
            const margin = window.getComputedStyle(componentNativeElement).getPropertyValue('margin');

            this.viewContainer.clear();
            this.instantiateSpinner(width, height, margin);
        } else {
            this.viewContainer.clear();
            this.embeddedView = this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private instantiateSpinner(width: number, height: number, margin: string): void {
        // create the spinner
        const factory = this.componentFactoryResolver.resolveComponentFactory(MatSpinnerContainerComponent);
        const spinner = this.viewContainer.createComponent(factory);

        // configure the spinner
        spinner.instance.diameter = this.diameter;
        spinner.instance.strokeWidth = this.strokeWidth;
        spinner.instance.width = width;
        spinner.instance.height = height;
        spinner.instance.margin = margin;
    }
}
